module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x160-d5b9cf943dcc4eebdf121cc43097347a.webp";